import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {

  constructor() { }
  public class_table;
  public categories_table;
  public class_details_table;
  
  classTable(){
    this.class_table = [
      {c_id:1,name:'100L',description:'First Year'},
      {c_id:2,name:'200L',description:'Sophomore'},
      {c_id:3,name:'300L',description:'Third Year'},
      {c_id:4,name:'400L',description:'Fourth year'}
    ];
  }
  classDetailsTable(){
    this.class_details_table = [
      {cd_id:1,c_id:1,student_id:1,cat_id:3},
      {cd_id:2,c_id:3,student_id:2,cat_id:2},
      {cd_id:3,c_id:2,student_id:3,cat_id:1},
    ];
  }

  categoriesTable(){
    this.categories_table = [
      {cat_id:1,category:"CSE",description:"Computer Science and Engineering",staff_id:1,faculty_id:1},
      {cat_id:1,category:"MEE",description:"Mechanical Engineering",staff_id:2,faculty_id:2},
      {cat_id:1,category:"EEE",description:"Electrical Engineering",staff_id:3,faculty_id:3}
    ];
  }

 
}
